import EventEmitter from './../services/EventEmitter'

export default {
  methods: {
    notify: function (msg) {
      EventEmitter.$emit('admin.notify', msg)
    },
    notifyError: function (msg) {
      EventEmitter.$emit('admin.notify-error', msg)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Notify.js